module.exports = __webpack_public_path__ + "static/media/iso50001.e140ce7b.svg";